<template>
  <div class="page">
    <div class="app-container">
      <BaseTable
        ref="baseTable"
        url="/admin/insBillPay/getPayChannel"
        :tableData.sync="tableData"
        :columns="columns"
		:searchParams="searchData"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" v-if="row.status == 1" @click="edit(row, '0')">启用</el-button>
		  <el-button type="text" size="mini" v-if="row.status == 0"  @click="edit(row, '1')">禁用</el-button>
        </template>
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { columns } from "./columns";

export default {
  name: "Config",
  comments: {},
  data() {
    return {
	  tableData: [],
	  formData: {
		  value: '',
		  status: 0
	  },
	  searchData: {},
    };
  },
  computed: {
    columns
  },
  created() {},
  methods: {
    edit(row, status) {
      this.$api.post('/admin/insBillPay/saveChannel', {
      	'id': row.id,
      	'status': status,
      }).then(() => {
	    this.$refs.baseTable.searchData();
	  });
      //this.handleSearch();
    },
	// 点击搜索
	handleSearch() {
	  // console.log(this.searchData);
	  this.$refs.baseTable.searchData();
	},
  },
};
</script>
